import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=9c5c31ae&scoped=true"
import script from "./custom.vue?vue&type=script&lang=js"
export * from "./custom.vue?vue&type=script&lang=js"
import style0 from "./custom.vue?vue&type=style&index=0&id=9c5c31ae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5c31ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c5c31ae')) {
      api.createRecord('9c5c31ae', component.options)
    } else {
      api.reload('9c5c31ae', component.options)
    }
    module.hot.accept("./custom.vue?vue&type=template&id=9c5c31ae&scoped=true", function () {
      api.rerender('9c5c31ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/baseFile/custom.vue"
export default component.exports